module.exports = __webpack_public_path__ + "static/media/icoFreezone.9c83fc94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/icoFreezone.svg
// module id = 109
// module chunks = 0